$(function() {
  let $form = $('.js-inquiry-templates-form');
   $($form).find('input').on('click', function(){
       $form.submit();
   });
});
